import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../lib/services";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

export default function Services() {
  return (
    <div className="pt-36 pb-8" data-testid="services-page">
      <Seo path="/services" title={PAGE_SEO["/services"].title} description={PAGE_SEO["/services"].description} />
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="kb-label mb-6">Our Services</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] max-w-4xl">
            Every compliance. <br /><span className="italic text-[#d4a840]">One partner.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-lg text-white/70 max-w-3xl leading-relaxed">
            Fifteen verticals. Hundreds of specialised offerings. One accountable partner for
            your entire regulatory, licensing and legal universe.
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.slug} delay={i * 0.03}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-card-${s.slug}`}
                className="group block h-full kb-glass rounded-2xl p-7 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="h-12 w-12 rounded-xl bg-[#d4a840]/10 border border-[#d4a840]/30 flex items-center justify-center group-hover:bg-[#d4a840]/20 transition-colors">
                    <Icon size={22} className="text-[#d4a840]" />
                  </div>
                  <ArrowRight size={18} className="text-white/40 group-hover:text-[#d4a840] group-hover:translate-x-1 transition-all" />
                </div>
                <h2 className="font-display text-xl md:text-2xl font-semibold text-white leading-snug">{s.title}</h2>
                <p className="mt-3 text-sm text-white/60 leading-relaxed">{s.tagline}</p>
                <div className="mt-5 pt-5 border-t border-[#d4a840]/10 flex flex-wrap gap-2">
                  {s.items.slice(0, 3).map((it) => (
                    <span key={it} className="text-[11px] uppercase tracking-widest text-white/60 border border-white/10 rounded-full px-2.5 py-1">
                      {it}
                    </span>
                  ))}
                  {s.items.length > 3 && (
                    <span className="text-[11px] uppercase tracking-widest text-[#d4a840]/80">+{s.items.length - 3} more</span>
                  )}
                </div>
              </Link>
            </Reveal>
          );
        })}
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 mt-24 text-center">
        <Reveal>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-tight">
            Don't see what you need? <br /><span className="italic text-[#d4a840]">Ask us.</span>
          </h2>
          <p className="mt-4 text-white/70">Our advisory network covers regulatory frameworks nationwide.</p>
          <div className="mt-8">
            <Link to="/contact" className="kb-btn-primary" data-testid="services-cta">Get in touch</Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
